import api from "../../api/database";

const state = {
    programSelectionMenu: [],
    commentaryMenu:{},
    getYearCompleted: true

}

const getters = {
    currentProgramSelectionMenu: state => state.programSelectionMenu,
    currentCommentaryMenu:state => state.commentaryMenu,
    getYearCompletedStatus:state => state.getYearCompleted,

}

const actions = {
    async getMenuOptions({commit}, all = false){
        /*
        if (localStorage.getItem('commentary_menu') && localStorage.getItem('program_selection_menu')) {
            commit('setProgramSelectionMenu', JSON.parse(localStorage.getItem('program_selection_menu')))
            commit('setCommentaryMenu', JSON.parse(localStorage.getItem('commentary_menu')))
            return;
        }
        */
        commit('setYearCompleted', true);
        const response = await api.getMenuOptions(all);
        if(response && response['data']['status'] == "success"){
            commit('setYearCompleted', false);
            console.log(`Success: getMenuOptions`)
            console.log(`data: ${JSON.stringify(response['data']['data'])}`);
            /*
            localStorage.setItem('program_selection_menu', JSON.stringify(response['data']['data']['program_selection_menu']));
            localStorage.setItem('commentary_menu', JSON.stringify(response['data']['data']['commentary_menu']));
            */
            commit('setProgramSelectionMenu', response['data']['data']['program_selection_menu'])
            commit('setCommentaryMenu', response['data']['data']['commentary_menu'])
        } else {
            console.log('Logging error: Getting Menu Options')
            console.log(response)
        }
    }
}

const mutations = {
    setProgramSelectionMenu: (state, data) => {
        state.programSelectionMenu = data;
    },
    setCommentaryMenu: (state,data) => {
        state.commentaryMenu = data;
    },
    setYearCompleted: (state, data) => {
        state.getYearCompleted = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}